<template>
  <div class="bbe-templates-save">
    <FoldersTree class="bbe-templates-save__folders-tree" @setFolder="setFolder"/>
    <label for="template-name" class="bbe-templates-save-label">
       <span class="bbe-templates-save-label__title">
              Save as
            </span>
      <input class="bbe-input bbe-input_border"
             :class="{'bbe-input_border_error': error}"
             type="text"
             id="template-name"
             name="template-name"
             v-model="templateName"
             @input="setTemplateName">
      <template name="bounce">
        <span v-if="error" class="bbe-templates-save-label__error bbe-label bbe-label__error">{{error}}</span>
      </template>
    </label>
  </div>
</template>

<script>
import FoldersTree from '@/components/Templates/FoldersTree/FoldersTree'

export default {
  name: 'TemplateSaveFromMail',
  props: ['saveError', 'name'],
  components: {
    FoldersTree
  },
  data () {
    return {
      templateName: '',
      error: ''
    }
  },
  methods: {
    setTemplateName () {
      this.$emit('getName', this.templateName)
    },
    setFolder (folder) {
      this.$emit('getFolder', folder)
    }
  },
  watch: {
    saveError () {
      this.error = this.saveError
    }
  },
  beforeMount () {
    this.templateName = this.name || ''
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-templates-save {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    &__folders-tree {
      margin-top: 19px;
    }

    &-label {
      min-width: calc(100% - 36px);
      margin: 16px auto 35px;

      &__error {
        bottom: 19px;
        left: 18px;
      }

      &__folder-name {
        color: $color-accent;
      }

      &_delete {
        text-align: center;
        font-size: 14px;
        line-height: 17px;
      }

      &__title {
        display: inline-block;
        color: $color-silver-chalice;
        font-size: 12px;
        line-height: 14px;
        margin-bottom: 8px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Templates/TemplateSaveFromMail/TemplateSaveFromMail.vue